// ===========================================================================
// Clinical Design System — Tokens
//
// Fuente de verdad visual para los módulos de la Etapa 2 (BillingV2).
// Basado en docs/modulos/BillingV2/00_SISTEMA_DISENO_MEDICO.md.
//
// Concepto: "Clinical Operations Console" — denso, calmado, escaneable.
// Anti-patrones prohibidos: KPI tiles gigantes, gradientes morados,
// fuentes genéricas, sombras flotantes, emojis decorativos.
// ===========================================================================

export const tokens = {
  // Superficies en capas (no blanco plano)
  canvas: "#EEF1F3",
  surface: "#FFFFFF",
  surface2: "#F6F8F9",
  line: "#D8DEE2",
  lineStrong: "#B6C0C6",

  // Texto
  ink: "#16242B",
  ink2: "#4A5C66",
  ink3: "#7C8B93",

  // Primario clínico (teal petróleo)
  primary: "#0F6E6E",
  primary700: "#0A5252",
  primary50: "#E2F0EF",

  // Semántica clínica (estado, nunca decoración)
  ok: "#1F8A5B",
  okBg: "#E4F3EC",
  warn: "#B5760A",
  warnBg: "#FBF0DC",
  crit: "#C0392B",
  critBg: "#FBE7E4",
  info: "#1B5FA8",
  infoBg: "#E4EEF8",
  muted: "#7C8B93",
  mutedBg: "#EDF0F2",

  // Tipografía
  fontUI: "'IBM Plex Sans', 'Segoe UI', sans-serif",
  fontMono: "'IBM Plex Mono', 'Consolas', monospace",
};

// Mapa semántico: una sola fuente para pills/celdas/banners.
export const SEMANTIC = {
  ok:    { fg: tokens.ok,    bg: tokens.okBg,    dot: "●" },
  warn:  { fg: tokens.warn,  bg: tokens.warnBg,  dot: "◐" },
  crit:  { fg: tokens.crit,  bg: tokens.critBg,  dot: "▲" },
  info:  { fg: tokens.info,  bg: tokens.infoBg,  dot: "●" },
  muted: { fg: tokens.muted, bg: tokens.mutedBg, dot: "○" },
};

// Formato de moneda compartido (montos siempre en mono tabular).
export const fmtMoney = (n, opts = {}) =>
  (n ?? 0).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
    ...opts,
  });

export const fmtNumber = (n) => (n ?? 0).toLocaleString("en-US");

// Formatea ICD-10 crudo (E119 → E11.9) conservando el valor original aparte.
export const formatIcd10 = (raw) => {
  if (!raw || raw.includes(".") || raw.length <= 3) return raw;
  return `${raw.slice(0, 3)}.${raw.slice(3)}`;
};
